import { render, staticRenderFns } from "./CertificateTable.vue?vue&type=template&id=5848c562&scoped=true"
import script from "./CertificateTable.vue?vue&type=script&lang=js"
export * from "./CertificateTable.vue?vue&type=script&lang=js"
import style0 from "./CertificateTable.vue?vue&type=style&index=0&id=5848c562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848c562",
  null
  
)

export default component.exports